module.exports = __webpack_public_path__ + "img/project.76d96751.png";